import React, { useState, useEffect } from 'react';
import { TabMenu } from 'primereact/tabmenu';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import { useUserDetailsContext } from 'context/userDetailsContext';
import Header from './Header';
import Table from './Table';
import CaptureNowTable from './CaptureNowTable';

export default function OnlineLeadsList() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { checkSubPermission } = useUserDetailsContext();
  const showCaptureNow = checkSubPermission('capturenow');

  const tabItems = showCaptureNow ? [{ label: 'Online Forms' }, { label: 'CaptureNow' }] : [{ label: 'Online Forms' }];

  useEffect(() => {
    if (!showCaptureNow && activeIndex !== 0) {
      setActiveIndex(0);
    }
  }, [showCaptureNow, activeIndex]);

  return (
    <div className="container-fluid online-lead-list-page">
      <GlobalLoader />
      <Header title="Online Leads List" />

      {showCaptureNow ? <TabMenu model={tabItems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} /> : null}

      {activeIndex === 0 && (
        <div className="col-12 datatable-responsive card-bg mb-3 intake-form-table">
          <Table />
        </div>
      )}

      {showCaptureNow && activeIndex === 1 && (
        <div className="col-12 datatable-responsive card-bg mb-3 intake-form-table">
          <CaptureNowTable />
        </div>
      )}
    </div>
  );
}
